export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  PROFILE: '/profile/:userId',
  PROFILE_BASE: '/profile',
  FEED: '/feed',
  POST: '/post/:id',
  NOT_FOUND: '*',
};

export const buildProfilePath = (userId) => `/profile/${userId}`;
export const buildPostPath = (id) => `/post/${id}`;
